import { BsCheckCircle, BsExclamationCircle, BsInfoCircle, BsExclamationTriangle, BsCircle, BsStarFill, BsCpu } from "react-icons/bs";

export enum FeedBackType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  DEFAULT = 'default',
  ACHIEVEMENT = 'achievement',
  SYSTEM = 'system',
}


export const FeedBackConfig = {
  [FeedBackType.SUCCESS]: {icon : <BsCheckCircle />, title : 'Succés', message : 'Opération réussie.'},
  [FeedBackType.ERROR]: { icon : <BsExclamationCircle />, title : 'Erreur', message : 'Opération échouée.'},
  [FeedBackType.INFO]: {icon : <BsInfoCircle />, title : 'Information', message : 'Aucune information par défaut.'},
  [FeedBackType.WARNING]: {icon : <BsExclamationTriangle />, title : 'Attentention', message : 'Aucun warning par défaut.'},
  [FeedBackType.DEFAULT]: {icon : <BsCircle />, title : 'Défaut', message : 'Aucun message par défaut.'}, // ou rien, ou un point
  [FeedBackType.ACHIEVEMENT]: {icon : <BsStarFill />, title : 'Réalisation', message : 'Bravo, action réalisé.'}, // ou une coupe, badge
  [FeedBackType.SYSTEM]: {icon : <BsCpu />, title : 'Système', message : 'Aucun message système configuré'}, // ou BsGear, BsServer, etc.
};